import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-133fb406"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-wrap justify-content-center align-items-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_lazy_image = _resolveComponent("v-lazy-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dogimages, (dogimage, index) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "card mb-3 me-2",
        style: {"width":"17rem","min-height":"100%"},
        key: index
      }, [
        _createVNode(_component_v_lazy_image, {
          src: dogimage,
          width: "100",
          height: "150",
          class: "card-img-top",
          alt: "dog image",
          onClick: ($event: any) => (_ctx.selectDog(dogimage))
        }, null, 8, ["src", "onClick"])
      ]))
    }), 128))
  ]))
}